import { Component, OnInit, Inject } from '@angular/core';
import { SnackbarService } from '../snackbar.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Messages } from '../constants/messages';
@Component({
  selector: 'app-share',
  templateUrl: './share.component.html',
  styleUrls: ['./share.component.scss']
})
export class ShareComponent implements OnInit {
  errors = new Messages();
  constructor(@Inject(MAT_DIALOG_DATA) private parentData: any, private dialog: MatDialogRef<ShareComponent>,
              private snackbar: SnackbarService) { }
  track = '';
  ngOnInit() {
    this.track = this.parentData;
  }
  closeModal() {
    this.dialog.close();
  }
  copyUrl(trackingUrl) {
    trackingUrl.select();
    if (document.execCommand('copy')) {
      this.snackbar.openSnackBar(this.errors.SHARE.COPIED, '');
    }
    trackingUrl.setSelectionRange(0, 0);

  }
  sendEmail() {
    const email = '';
    const subject = 'Track Shipment Number';
    const emailBody = this.parentData;
    window.location.href = 'mailto:' + email + '?subject=' + subject + '&body=' + emailBody;
}
whatsApp() {
  const url = 'https://wa.me/?text=' + this.parentData;
  window.open(url);
}

}
